{
  "schemaVersion": "cogo.document-template-catalog.v1",
  "templates": [
    {
      "templateId": "golden-report-workspace",
      "templateVersion": "1.0.0",
      "name": "Golden report workspace",
      "description": "One-page business brief for deterministic rule-only versus model-assisted document evaluation.",
      "status": "promoted",
      "manifestRef": "./golden-report-workspace/manifest.json",
      "inputSchemaRef": "./golden-report-workspace/input.schema.json",
      "defaultInputRef": "./golden-report-workspace/default-input.json",
      "renderTargets": ["docx", "pdf"],
      "publicationTargets": ["google-docs", "notion"],
      "humanPromoted": true,
      "modelCanonicalAuthority": false,
      "evidence": {
        "evaluationRef": "docs/agentic/evidence/document-template-llm-vertical-slice/document-template-ab-evaluation.v1.json",
        "sourceRef": "packages/cogo-kg-browser/fixtures/test-fixtures/document-ontology/sources/coogo-three-pillar-growth-strategy-2026-07-16.md",
        "sourceHash": "sha256:07be17b1a8eca9477fa805524f714dce6208cd218415818057fac755edb82d1a",
        "arms": {
          "A": {
            "semanticContentHash": "sha256:78e3a84598b9961fa9185e852f376fe304b2c936e9e196ec1bb772226c85589b",
            "artifactRefs": [
              "docs/agentic/evidence/document-template-llm-vertical-slice/arm-a-rule-only/golden-report-workspace.docx",
              "docs/agentic/evidence/document-template-llm-vertical-slice/arm-a-rule-only/golden-report-workspace.pdf"
            ]
          },
          "B": {
            "semanticContentHash": "sha256:373ba85a742ef3a520167bb197526a67b5b17102db3166ceed2d43e9e12f031a",
            "artifactRefs": [
              "docs/agentic/evidence/document-template-llm-vertical-slice/arm-b-model-assisted/golden-report-workspace.docx",
              "docs/agentic/evidence/document-template-llm-vertical-slice/arm-b-model-assisted/golden-report-workspace.pdf"
            ]
          }
        }
      }
    },
    {
      "templateId": "standard-report",
      "templateVersion": "1.0.0",
      "name": "표준 보고서",
      "description": "표지·목차·요약·본문·부록 5부 구성 표준 보고서 템플릿 패밀리. 승격된 v1 manifest가 없어 manifest-free Generation IR v2 (flow-page) 경로로 컴파일된다.",
      "status": "calibration",
      "inputSchemaRef": "./standard-report/input.schema.json",
      "renderTargets": ["docx"],
      "publicationTargets": [],
      "humanPromoted": false,
      "modelCanonicalAuthority": false
    },
    {
      "templateId": "reb-report",
      "templateVersion": "1.0.0",
      "name": "부동산원 보고서",
      "description": "표지·목차·요약·본문·부록 5부 구성 부동산원(REB) project-scope 보고서 템플릿 패밀리. 승격된 v1 manifest가 없어 manifest-free Generation IR v2 (flow-page) 경로로 컴파일된다.",
      "status": "calibration",
      "inputSchemaRef": "./reb-report/input.schema.json",
      "renderTargets": ["docx"],
      "publicationTargets": [],
      "humanPromoted": false,
      "modelCanonicalAuthority": false
    }
  ]
}
